import "core-js/modules/es6.object.define-property";

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

export var EventUtils =
/*#__PURE__*/
function () {
  function EventUtils() {
    _classCallCheck(this, EventUtils);
  }

  _createClass(EventUtils, null, [{
    key: "dispatch",
    value: function dispatch(element, name) {
      // TODO check how we can trigger events of type !== Event (e.g. InputEvent)
      var event;

      if (typeof Event === "function") {
        event = new Event(name);
      } else {
        event = document.createEvent("Event");
        event.initEvent(name, true, true);
      }

      element.dispatchEvent(event);
    }
  }]);

  return EventUtils;
}();